<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row class="d-flex">
      <v-card
        flat
        class="card-full-width text-center"
      >
        <span class="section-header">About ezWave</span>
      </v-card>
      <v-card
        flat
        class="card-full-width pa-3 mt-0"
      >
        <p
          class="section-text"
        >
          ezWave is a progressive internet provider serving California's central valley.
          Our experienced team has deployed the latest technology to deliver big city speeds
          to the rural communities. With standard plans over 100 mbps, ezWave offers a fast
          and affordable internet solution for any need.
        </p>
      </v-card>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          class="mx-1 px-4 py-4"
        >
          <p
            class="section-header"
          >
            {{ businessName }} Office
          </p>
          <p
            class="section-text"
          >
            {{ businessAddress }}
          </p>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          class="mx-1 px-4 py-4"
        >
          <p
            class="section-header"
          >
            Mailing Address
          </p>
          <p
            class="section-text"
          >
            {{ mailingAddress }}
          </p>
          <p
            class="section-text"
          >
            Please use this address for all payments and written correspondences.
          </p>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          class="mx-1 px-4 py-4"
        >
          <p
            class="section-header"
          >
            Hours
          </p>
          <p
            class="section-text"
          >
            Technical support is available 24 hours a day by calling {{ businessPhone }} and pressing option 1 for support.
          </p>
          <p
            class="section-text"
          >
            Our office hours are Monday through Friday 8:00am to 5:00pm.
          </p>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'Plans',
    mixins: [basicMixin],

    data () {
      return {
      }
    },
    computed: {
    },
    async created () {
    },
    methods: {
    },
  }
</script>
